<!--
  Usage:
    <ReportShell
      v-model="dialog"
      title="Member Profile Report"
      subtitle="Know Your Customer (KYC) & Anti-Money Laundering Summary"
      :header-name="personalFullName"
      :ref-label="'Ref ' + shortRef(member.id)"
      @print="printReport"
    >
      <ReportSection title="Personal Information"> ... </ReportSection>
      <ReportSection title="Account Information"> ... </ReportSection>
    </ReportShell>
-->
<template>
  <v-dialog
    v-model="dialog"
    :max-width="maxWidth"
    scrollable
    overlay-opacity="0.8"
    persistent
  >
    <div class="report-dialog">

      <div class="report-header">
        <div class="d-flex align-center" style="gap:12px">
          <div class="header-icon">
            <v-icon color="#14243A">mdi-file-document</v-icon>
          </div>
          <div>
            <div style="font-size:15px;font-weight:600;color:#14243A">{{ title }}</div>
            <div style="font-size:11px;color:#9aa1ab">
              {{ headerName }}<span v-if="headerName"> &middot; </span>{{ formatDate(new Date()) }}
            </div>
          </div>
        </div>
        <div class="d-flex align-center" style="gap:8px">
          <button class="rpt-btn-ghost" @click="$emit('print')">
            <v-icon small left>mdi-printer</v-icon>
            Print
          </button>
          <button class="rpt-icon-btn" @click="dialog = false">
            <v-icon small>mdi-close</v-icon>
          </button>
        </div>
      </div>

      <div class="report-body">
        <div class="doc-sheet">

          <div class="letterhead">
            <div class="letterhead-brand">
              <img v-if="company.logo" :src="company.logo" class="brand-logo" alt="" />
              <div v-else class="brand-mark">{{ companyInitials }}</div>
              <div>
                <div class="brand-name">{{ company.name || 'Company name' }}</div>
                <div class="brand-address">{{ companyAddress || 'Address not on file' }}</div>
              </div>
            </div>
            <div class="doc-meta">
              <div class="doc-ref">{{ refLabel }}</div>
              <div class="doc-date">{{ formatDate(new Date()) }}</div>
            </div>
          </div>

          <div class="doc-title-block">
            <div class="doc-title">{{ title }}</div>
            <div v-if="subtitle" class="doc-subtitle">{{ subtitle }}</div>
          </div>

          <slot />

          <div class="doc-footer">
            <div class="doc-divider-heavy"></div>
            <div class="doc-footer-row">
              <span>Generated {{ formatDateTime(new Date()) }} &middot; for internal use only</span>
              <span>{{ company.name || 'Company name' }} &copy; {{ new Date().getFullYear() }}</span>
            </div>
            <div class="doc-footer-confidential">
              This document contains confidential customer information and is intended solely for authorized personnel. Unauthorized distribution is strictly prohibited.
            </div>
          </div>

        </div>
      </div>

      <div class="report-footer">
        <button class="rpt-btn-ghost" @click="dialog = false">
          <v-icon small left>mdi-close</v-icon>
          Close
        </button>
        <button class="rpt-btn-ghost" @click="$emit('print')">
          <v-icon small left>mdi-printer</v-icon>
          Print report
        </button>
      </div>

    </div>
  </v-dialog>
</template>

<script>
import reportFormatMixin from '../mixins/reportFormat.mixin';
import reportPrintMixin from '../mixins/reportPrint.mixin';

export default {
  name: 'ReportShell',

  mixins: [reportFormatMixin, reportPrintMixin],

  props: {
    value:      { type: Boolean, default: false },
    title:      { type: String, required: true },
    subtitle:   { type: String, default: '' },
    headerName: { type: String, default: '' },
    refLabel:   { type: String, default: '' },
    maxWidth:   { type: String, default: '880px' },
  },

  data: () => ({
    dialog: false,
    sectionRegistry: { order: [] },
  }),

  provide() {
    return { reportSectionRegistry: this.sectionRegistry };
  },

  watch: {
    value(val)  { this.dialog = val; },
    dialog(val) { this.$emit('input', val); },
  },
};
</script>